import { Component, OnInit, ErrorHandler } from '@angular/core';
import { UserService } from '../../../shared/user.service';
import { Router, ActivatedRoute } from '@angular/router';
// import { TitleCasePipe } from '@angular/common';
import swal from 'sweetalert2';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'agreements-form',
  templateUrl: './agreements-form.component.html',
  styleUrls: ['./agreements-form.component.css']
})
export class AgreementsFormComponent implements OnInit {

  data: any;
  AG: any = {};
  aa : any={};
  AgreementType: any = [];
  AT: any = [];
  AllotmentType: any = [];
  ALT: any = {};
  PaymentType: any = [];
  PT: any = {};
  LesserDetails: any = [];
  LD: any = {};
  LesseeDetails: any = [];
  L: any = {};
  Projectlist: any = [];
  PD: any = {};
  Propertylist: any = [];
  PL: any = {};
  mode: any;
  title: string;
  PD_Id: any;
  CustomerList: any = {};
  CUST_ID: any;
  listOfless: any=[];
  li: any={};
  PropertyTemp: any = [];
  PropertyAgreementList: any = [];
  PG: any={};
  AgreementList: any = [];
  OA: any = {};
  REQP_ID: any;
  isSearch: boolean;
  ApprovalList: any = [];
  totalItems: any;
  itemsPerPage: number;
  currentPage: number;
  RequestProperty: any = [];
  BackId: any;
  Agrmnt_Id: any;
  fileToUpload: File;
  Total: any;
  PaymentFrequency: any;
  Applant_Type: any;
  formSubmitted:boolean;
  hide:any;
  constructor(private userService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler,
    ) {
  }

  ngOnInit() {
    this.GetAgreementType();  
    this.GetAllotmentType();
    this.GetPaymentType();
    this.GetPaymentFrequency();
    this.GetLesserDetails();
    this.GetLesseeDetails();
    this.GetProjectAgreement();
    this.GetOldAgreement();

    this.route.params.subscribe(params => {
      debugger;
      this.PD_Id = params['PD_Id'];
      this.CUST_ID = params['CUST_ID'];
      this.REQP_ID = params['REQP_ID'];
      this.BackId = params['BackId']; 
      this.Agrmnt_Id = params['Agrmnt_Id'];
      this.mode = params['mode'];
      this.Applant_Type = params['Applant_Type'];
      
      if (this.REQP_ID > 0) {
        this.GetByIdRequestProperty(this.REQP_ID)
      }
    })
    if (this.mode == 'View') {
      this.title = "View Agreements ";
    }
    else if (this.mode == 'Edit') {
      this.title = "Edit Agreements ";
    }
    this.Agrmnt_Id = localStorage.getItem('Agrmnt_Id')

  }
 
  GetOldAgreement() {
    debugger;
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.GetOldAgreement();
    this.data.subscribe(
      (response: any) => {
        this.AgreementList = response.Result;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
      });
  }

  GetAgreementType() {
    debugger;
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.GetAgreementType();
    this.data.subscribe(
      (response: any) => {
        if(this.Applant_Type=='Renewal')
        this.AG.Agrmnt_Type=6;
        this.AgreementType = response.Result;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
      });
  }

  GetAllotmentType() {
    debugger;
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.GetAllotmentType();
    this.data.subscribe(
      (response: any) => {
        this.AllotmentType = response.Result;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
      });
  }

  GetPaymentType() {
    debugger;
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.GetPaymentType();
    this.data.subscribe(
      (response: any) => {
        this.PaymentType = response.Result;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
      });
  }

  GetPaymentFrequency() {
    debugger;
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.GetPaymentFrequency();
    this.data.subscribe(
      (response: any) => {
        this.PaymentFrequency = response.Result;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
      });
  }

  GetLesserDetails() {
    debugger;
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.GetLesserDetails();
    this.data.subscribe(
      (response: any) => {
        this.LesserDetails = response.Result;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
      });
  } 

  GetLesseeDetails() {
    debugger;
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.GetLesseeDetails();
    this.data.subscribe(
      (response: any) => {
        this.listOfless = response.Result;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
      });
  } 

  GetCustomerDetailsById(CUST_ID) {
    debugger;
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.GetCustomerDetailsById(CUST_ID);
    this.data.subscribe(
      (response: any) => {
        this.CustomerList = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
      });
  } 

  GetProjectAgreement() {
    debugger;
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.GetProjectAgreement();
    this.data.subscribe(
      (response: any) => {
        this.Projectlist = response.Result;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
      });
  } 
  
  // GetRequestPropertyDetails(REQP_ID) {
  //   debugger;
  //   document.getElementById('loader-spinner').style.display = "block";
  //   this.data = this.userService.GetRequestPropertyDetails(REQP_ID);
  //   this.data.subscribe(
  //     (response: any) => {
  //       this.Propertylist = response;
  //       document.getElementById('loader-spinner').style.display = "none";
  //     }, (error) => {
  //       document.getElementById('loader-spinner').style.display = "none";
  //     });
  // } 
  
  // AddProperty(PG) {
  //   debugger;
  //   let temp = {
  //     Agrmnt_Id_D: PG.Agrmnt_Id_D,
  //     Agr_Proj_Id: PG.Agr_Proj_Id,
  //     Agr_Property_Id: PG.Agr_Property_Id,
  //     Building_Details: PG.Building_Details,
  //     Rate: PG.Rate,
  //     Maintenance_Cost: PG.Maintenance_Cost,
  //     GST_Rate: PG.GST_Rate,
  //     TDS_Rate: PG.TDS_Rate,
  //     PD_Project_Name: this.getProject(PG.Agr_Proj_Id),
  //     PropertyReqNumber: this.getProject(PG.Agr_Property_Id)
  //   }
  //   this.PropertyTemp.push(temp)
  //   this.PG={}
  // }

  // getProject(Agr_Proj_Id)
  // {
  //    for(let i=0; i<this.Projectlist.length;i++)
  //    {
  //      if(this.Projectlist[i].PD_Id==Agr_Proj_Id)
  //      return this.Projectlist[i].PD_Project_Name;
  //    }
  // }
  // getProperty(Agr_Property_Id)
  // {
  //    for(let i=0; i<this.Propertylist.length;i++)
  //    {
  //      if(this.Propertylist[i].PR_Id==Agr_Property_Id)
  //      return this.Propertylist[i].PropertyReqNumber;
  //    }
  // }
  Delete(i) {
      swal({
        title: 'Are you sure?', text: "You want to delete!", type: 'warning', showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          this.PropertyTemp.splice(i,1)
        }
      })
  }

  CancelAll() {
    this.AG={};
    this.PG={};
    this.CustomerList={};
    }

  Cancel() {
    this.PG={};
    }

  CreateAgreementDetails(PropertyAgreement) {
    debugger;
    // PropertyAgreement.value.PropertyAgreement = this.PropertyTemp;   //Removed form so comment this
    // PropertyAgreement.value.Lessee_Adress = this.PG.CUST_ADRSS1;
    // PropertyAgreement.value.Lessee_Contact = this.PG.CUST_CNT_NO;
    // PropertyAgreement.value.Lessee_Details = this.PG.CUST_ID;
    // PropertyAgreement.value.Agr_REQP_Id = this.PG.REQP_ID;
    // PropertyAgreement.value.PropertyAgreement=this.Propertylist;
    PropertyAgreement.PropertyAgreement = this.PropertyTemp;   
    PropertyAgreement.Lessee_Adress = this.PG.CUST_ADRSS1;
    PropertyAgreement.Lessee_Contact = this.PG.CUST_CNT_NO;
    PropertyAgreement.Lessee_Details = this.PG.CUST_ID;
    PropertyAgreement.Agr_REQP_Id = this.PG.REQP_ID;
    PropertyAgreement.PropertyAgreement=this.Propertylist;
    this.data = this.userService.CreateAgreementDetails(PropertyAgreement);

    PropertyAgreement.DOC_UPLOAD_PATH = this.getAgreementPDFUrl();
    this.data.subscribe(
        (response) => {
          // PropertyAgreement.reset();
          // PropertyAgreement.resetForm();
          // PropertyAgreement.form.markAsPristine();
          // PropertyAgreement.form.markAsUntouched();

          swal('Success!', 'Property Agreement Details Added Successfully .', 'success');
          this.router.navigate(['/home/agreements']);
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          if (error.status == 401 || error.status == 500) {
            this.errorHandler.handleError(error);
          }
          else if (error.status == 400) {
            swal('Warning!', error.error.Message, 'warning');
          }
        });
  }

  GetByIdRequestProperty(REQP_ID) {
    debugger;
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.GetByIdRequestProperty(REQP_ID);
    this.data.subscribe(
      (response: any) => { 
        this.PG = response;
        this.Propertylist = response.RequestProperty;
        
        if(response.AgreementGetById!=null)
        this.AG = response.AgreementGetById;
        if (this.AG.DOC_DATE != null)
          this.AG.DOC_DATE = ((this.AG.DOC_DATE).split('T'))[0];
        if (this.AG.Start_Date != null)
          this.AG.Start_Date = ((this.AG.Start_Date).split('T'))[0];
        if (this.AG.End_Date != null)
          this.AG.End_Date = ((this.AG.End_Date).split('T'))[0];
          document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
           document.getElementById('loader-spinner').style.display = "none";
      });
  }

  UpdatePropertyAgreement(PropertyAgreement) {
    debugger;
    PropertyAgreement.DOC_UPLOAD_PATH = this.getAgreementPDFUrl();
    PropertyAgreement.Agrmnt_Id =this.AG.Agrmnt_Id;
    PropertyAgreement.PropertyAgreement =this.Propertylist;
    this.data = this.userService.UpdatePropertyAgreement(PropertyAgreement.Agrmnt_Id,PropertyAgreement);
    this.data.subscribe(
      (response) => {
        //this.P = response;
        //this.GetProperty(this.P.PD_Id, this.P.REQP_CA_ID);
        swal('Success!', ' Property Agreement details updated Successfully .', 'success');
        document.getElementById('loader-spinner').style.display = "none";
        this.router.navigate(['/home/agreements']);
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        if (error.status == 401) {
          this.errorHandler.handleError(error);
        }
      });
  }

  GetAllRequestPropertyApprovalDetails(itemsPerPage: number, pageNo: number) {
    debugger;
    this.isSearch = false;
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.GetAllRequestPropertyApprovalDetails(itemsPerPage, pageNo)
      .subscribe(
        (data: any) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.ApprovalList = data.RequestPropertyApprovalModel;
          console.log(this.ApprovalList)
          this.totalItems = data.TotalItemsCount;
          this.itemsPerPage = itemsPerPage;
          this.currentPage = pageNo;
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.handleError(error);
        });
  }

  imageUpload(file: FileList) {
    debugger;
        let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;
    
        let s: any = file.item(0).size / 1024;
        let size: any = parseFloat(s).toFixed(2);
        let uploadedFilename = file.item(0).name;
        if (uploadedFilename.match(regex) && (size <= 5048)) {
          this.fileToUpload = file.item(0);
          var reader = new FileReader();
          reader.onload = (event: any) => {
          }
          reader.readAsDataURL(this.fileToUpload);
          const data = new FormData(); 
          data.append("UploadedImage", file.item(0));
          let x = this.userService.uploadImageRecovery(data);
          x.subscribe(
            (response) => {
            }, (error) => {
              let i: any = document.getElementById('DOC_UPLOAD_PATH');
              i.value = "";
              if (error.status == 400) {
                swal('Warning!', error.error.Message, 'warning');
              }
            });
        }
        else {
          let i: any = document.getElementById('DOC_UPLOAD_PATH');
          i.value = "";
          if (!uploadedFilename.match(regex))
            swal('Warning!', "Please upload PDF file with extension pdef or pdf", 'warning');
          else if (size > 2048)
            swal('Warning!', "Please upload image file less than 2mb", 'warning');
        }
      }

      getAgreementPDFUrl() {
        let imagename = null;
        try {
          imagename = document.getElementById('DOC_UPLOAD_PATH');
          return imagename.files[0].name;
        }
        catch (e) {
          return null; 
        }
      }
      
      GetTotal(Rate,Maintenance_Cost,GST_Rate,TDS_Rate)
      {
        debugger;
       let total=(parseFloat(Rate || 0) + parseFloat(Maintenance_Cost || 0) + (GST_Rate / 100) - (TDS_Rate / 100));
       this.PL.TotalAmount=total;
       console.log("totalamount");
       console.log(this.PL.TotalAmount);
      } 
         
}



// WEBPACK FOOTER //
// ./src/app/recovery/Agreements/agreements-form/agreements-form.component.ts